import { ErrorMessageKeys } from '@api/errors/models/error-message-keys.types';

export const GLOBAL_ERROR_MESSAGE_KEYS_BY_ERROR_CODE = {
  PERMISSION_CDM_REQUIRED: 'errors.permissionCdmRequired',
  PERMISSION_HOLDER_REQUIRED: 'errors.permissionHolderRequired',
  PERMISSION_IDENTITY_READ_ONLY: 'errors.permissionIdentityReadOnly',
  PERMISSION_OUT_OF_PERIMETER: 'errors.permissionOutOfPerimeter',
  PAYLOAD_TOO_LARGE: 'errors.unexpected',
} as const satisfies ErrorMessageKeys;

export const FALLBACK_ERROR_MESSAGE_KEY = 'errors.unexpected';

// Codes of the Notion error database the backend does not send yet (absent from the OpenAPI ErrorCode / FieldErrorCode).
// Not handled: add each one to the list of its owning feature, with its message, once it reaches the schema.
//   Global:
//     RESOURCE_NOT_FOUND (404), ACCESS_DENIED (403), AUTH_SESSION_EXPIRED (SESSION_EXPIRED is handled)
//   Droits & statuts (folders / actions):
//     ACTION_LOCKED_IN_INSTRUCTION, ACTION_MISSING_REQUIRED_INDICATORS, ACTION_REVERTED_TO_DRAFT,
//     FOLDER_LOCKED_IN_INSTRUCTION, FOLDER_DELETE_BLOCKED_STATUS, FOLDER_ACTIONS_NOT_COMPLETED,
//     FOLDER_NO_ACTIONS, FOLDER_MISSING_REQUIRED_INDICATORS
//   Association d'objets (shared/association-modal, agents, folders):
//     ASSOC_BENEFICIARY_HAS_LINKED_OBJECTS, ASSOC_HOLDER_NOT_ELIGIBLE, FOLDER_ACTIONS_LOCKED_STATUS
//   Sent under another code, already handled:
//     ASSOC_AGENT_COLLECTIVITY_CHANGE_BLOCKED -> AGENT_HAS_LINKED_ACTIONS_REASSIGN,
//     ASSOC_AGENT_DELETE_BLOCKED -> AGENT_HAS_LINKED_ACTIONS_DELETE,
//     ASSOC_AGENT_WRONG_COLLECTIVITY -> PERMISSION_AGENT_OUT_OF_SCOPE,
//     ASSOC_BUILDING_WRONG_COLLECTIVITY -> PERMISSION_SITE_OUT_OF_SCOPE
//   Empty states (no HTTP error, 200 + empty list): CLIENT_NO_AGENTS_AVAILABLE, CLIENT_NO_BUILDINGS_AVAILABLE
//   Intégrations externes: EXT_BANATIC_UNAVAILABLE
//   Validation formulaire (field codes): VALIDATION_GROUP_INCOMPLETE, VALIDATION_INVALID_DATE
//   Client side: FILE_UPLOAD_FAILED (network error during an upload)
